import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { faCopy, faEllipsisVertical, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { NSButton } from 'bricks';

type ActivityActionsMenuProps = {
    onDuplicate: () => void;
    onDelete: () => void;
    dataTestIdPrefix: string;
};

const ActivityActionsMenu = ({ onDuplicate, onDelete, dataTestIdPrefix }: ActivityActionsMenuProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(prev => !prev)} direction="down">
            <DropdownToggle tag="button" className="btn p-0 border-0 bg-transparent">
                <NSButton color="secondary" icon={faEllipsisVertical} ariaLabel="Activity actions" />
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem onClick={onDuplicate} className="text-white" data-testid={`${dataTestIdPrefix}-duplicate`}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Duplicate task</span>
                        <FontAwesomeIcon icon={faCopy} />
                    </div>
                </DropdownItem>
                <DropdownItem onClick={onDelete} className="text-white" data-testid={`${dataTestIdPrefix}-delete`}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Delete task</span>
                        <FontAwesomeIcon icon={faTrash} />
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ActivityActionsMenu;
